import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ApiError } from "@/api/client";
import { useWorkbookStore } from "@/stores/workbook";

export function WorkbookNewPage() {
  const navigate = useNavigate();
  const createDraft = useWorkbookStore((state) => state.createDraft);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const workbookId = await createDraft("Current User");
        if (!cancelled) {
          navigate(`/workbook/${workbookId}/edit?created=1`, { replace: true });
        }
      } catch (err) {
        if (!cancelled) {
          const message =
            err instanceof ApiError
              ? `API error ${err.status}`
              : err instanceof Error
                ? err.message
                : "unknown error";
          toast.error("Unable to create workbook", { description: message });
          navigate("/workbook", { replace: true });
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [createDraft, navigate]);

  return null;
}
